import { render, staticRenderFns } from "./SidebarGroup.vue?vue&type=template&id=4f905c26&scoped=true"
import script from "./SidebarGroup.vue?vue&type=script&lang=js"
export * from "./SidebarGroup.vue?vue&type=script&lang=js"
import style0 from "./SidebarGroup.vue?vue&type=style&index=0&id=4f905c26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f905c26",
  null
  
)

export default component.exports